import { render, staticRenderFns } from "./Inspecciones.vue?vue&type=template&id=0f667813&"
import script from "./Inspecciones.vue?vue&type=script&lang=js&"
export * from "./Inspecciones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports